const dynamicPlanOptions = [
  'plan_opt_checks_number_unlim',
  'plan_opt_checks_number_year',
];

function isWithDynamicContent(planOption: string) {
  return dynamicPlanOptions.some((option) => option === planOption);
}

function getPlanOptionTranslation(planOption: string) {
  if (planOption[0] === '!') {
    return {
      isActive: false,
      translation: `translation.${planOption.slice(1)}`,
      withContent: isWithDynamicContent(planOption.slice(1)),
    };
  }

  return {
    isActive: true,
    translation: `translation.${planOption}`,
    withContent: isWithDynamicContent(planOption),
  };
}

export default getPlanOptionTranslation;
